'use client';

import { useDealerLocatorModal } from 'components/dealer-locator/dealer-locator-modal-context';
import { RegisterButton as RegisterButtonPCC } from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import { CONSENT } from 'constants/storageConstants';
import { getSessionStorage } from '@cat-ecom/common/utils/storageUtils';
import { useUserConsentModal } from 'components/user-consent-modal/user-consent-modal-context';
import { useNavigationDrawers } from '../navigation-drawers-context';
import { BUTTON_VARIANTS } from '@cat-ecom/pcc-components/src/constants/commonConstants';

interface GaAttributes {
  'data-track-event': string;
  'data-track-attr-nltext': string;
  'data-track-attr-context': string;
}

export const RegisterButtonClient = ({
  className,
  isLocationSelected,
  url,
  isLoggedIn,
  variant,
  fullWidth,
  buttonText,
  skipRegisterDrawer,
  gaAttributes
}: {
  className?: string;
  isLocationSelected: boolean;
  url?: string;
  isLoggedIn: boolean;
  variant?: BUTTON_VARIANTS;
  fullWidth?: boolean;
  buttonText?: string;
  skipRegisterDrawer?: boolean;
  gaAttributes?: GaAttributes;
}) => {
  const t = useTranslations();
  const dealerLocatorModal = useDealerLocatorModal();
  const { getOpenDrawer } = useNavigationDrawers();
  const userConsentModal = useUserConsentModal();
  const isConsentSelected = JSON.parse(getSessionStorage(CONSENT));
  const showUserConsentModal =
    isLocationSelected && !isConsentSelected && !isLoggedIn;

  const onClick = () => {
    if (!skipRegisterDrawer) {
      const drawer = getOpenDrawer();
      drawer?.closeDrawer();
    }

    if (showUserConsentModal) {
      userConsentModal.modalControl.open();
    } else {
      dealerLocatorModal.modalControl.open();
    }
  };

  return (
    <RegisterButtonPCC
      onClick={url && !showUserConsentModal ? undefined : onClick}
      className={className}
      href={showUserConsentModal ? undefined : url}
      variant={variant}
      fullWidth={fullWidth}
      gaAttributes={gaAttributes}
    >
      {buttonText || t('SL_REGISTER')}
    </RegisterButtonPCC>
  );
};
